import { Observable } from 'rxjs';

export enum BrowserPermission {
  granted = 'granted',
  denied = 'denied',
  prompt = 'prompt',
  unknown = 'unknown',
  timeout = 'timeout',
}

export type BrowserLocation = {
  Latitude: number;
  Longitude: number;
  Altitude?: number;
  Speed?: number;
  DateTime: number;
};

export type BrowserFailure = {
  name: string;
  message: string;
  stack?: string | undefined;
};

export abstract class BrowserService {
  abstract userAllowedFallbackConsent(): boolean;
  abstract setUserAllowedFallbackConsent(permission: boolean): void;
  abstract getLocationPermission(): Observable<BrowserPermission>;
  abstract getLocation(): Observable<GeolocationPosition>;
  abstract isInApp(): boolean;
}
